module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/nus-assessment-l2/nus-assessment-l2.component.css
// module id = ./src/app/nus-assessment-l2/nus-assessment-l2.component.css
// module chunks = main